import { render, staticRenderFns } from "./Basicdata.vue?vue&type=template&id=38416464&scoped=true"
import script from "./Basicdata.vue?vue&type=script&lang=js"
export * from "./Basicdata.vue?vue&type=script&lang=js"
import style0 from "./Basicdata.vue?vue&type=style&index=0&id=38416464&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38416464",
  null
  
)

export default component.exports